<template slot="header">

  <div class="ti-table ti_border"
       v-bind:class="{ ti_dashedborder: hasDashBorder, ti_space: !isHeader }"
       v-b-tooltip.hover no-fade
       :title="getTooltipText"
       v-show="getIsAvailable">

    <div class="ti-headerrow ti-cell"
         v-bind:class="{ ti_bg: isHeader, ti_bg_lite: !isHeader }">
      <div style="display: inline-flex; float:left;">
        <p v-bind:class="{  narrow_05: isNarrow, narrow_10: isVeryNarrow, localheading: isHeader }">
          <font-awesome-icon name="fa-thumbs-up" icon="star" v-if="hasStar"></font-awesome-icon>
            {{ getKpiName }}
          </p>
      </div>
      <div v-show="isHeader && hasNsc && !hideNSC" style="float: right; display: inline-flex">
        <NarrowNscItem v-bind:kpi="kpi" />
      </div>
    </div>

    <div class="ti-row">
      <div class="ti-cell">
        <compareitem :overallByWave="overallByWave"
                      :kpi="kpi"
                      :monochrome="monochrome" />
      </div>
    </div>
  </div>

</template>


<script>

  import compareitem from './CompareItem'
  import NarrowNscItem from './NarrowNscItem'

  export default {
    name: 'BMWMTableItem',
    components: {
      compareitem,
      NarrowNscItem
    },
    props:[
      'overallByWave',
      'kpi',
      'hideNSC',
      'nsckpi',
      'hasStar',
      'isHeader',
      'hasDashBorder',
      'monochrome',
      'isSmaller',
    ],
    methods:{
      isLongText: function (text) {
        if (text === null) {
          return false;
        }
        return text.length > 24
      }
    },
    computed: {
      getTooltipText: function() {
        if (!this.kpi || !this.kpi.QuestionText)
          return ''
        return this.kpi.QuestionText
      },
      isNarrow: function () {
        if (!this.kpi || !this.kpi.KpiName) { return false }
        return this.kpi.KpiName.length > 22 && this.kpi.KpiName.length <= 30
      },
      isVeryNarrow: function () {
        if (!this.kpi || !this.kpi.KpiName) { return false }
        return this.kpi.KpiName.length > 30
      },
      getKpiName: function() {
        if (!this.kpi || !this.kpi.KpiName) {
           return 'nicht verfügbar'
        }
        return this.kpi.KpiName
      },
      getIsAvailable: function() {
          if (!this.kpi || !this.kpi.KpiName) {
           return false
        }
        return true
      },
      hasNsc: function() {
        if (!this.kpi || !this.kpi.Competition || _.size(this.kpi.Competition) === 0) {
          return false
        }
        var result =  this.kpi.Competition[0].Points
        return result  != undefined
      }
    }
  }

</script>


<style scoped>

  .localheading {
     font-size: 12pt;
  }

  .narrow {
    letter-spacing: -0.05em;
    width: 160px;
    text-overflow: ellipsis;
  }

  dic.ti-cell{
    align-content: center;
    align-content: space-around;
  }

  p{
    font-size: 8pt;
    font-weight: bold;
    font-stretch: extra-condensed;
    margin-bottom:0px;
    margin-left: 3px;
  }


</style>
